// react and mui stuff
import { useEffect, useState } from "react";

import FormControl from "@mui/joy/FormControl"
import FormLabel from "@mui/joy/FormLabel"
import IconButton from "@mui/joy/IconButton"
import Input from "@mui/joy/Input"
import { BarChart } from "@mui/x-charts/BarChart";

import Refresh from "@mui/icons-material/Refresh";

// custom components
import { ChannelXPReport } from "../../types/reports";

// data and stuff
import { reportAPI } from "../../utils/backend"
import { FetchButton, ReportProps } from "./utils";

export default function ChannelXpReport({ report, setReport, setToast, setUser, user }: ReportProps<ChannelXPReport>) {
  const [loading, setLoading] = useState(false);
  const [threshold, setThreshold] = useState(1000)
  const [displaying, setDisplaying] = useState<ChannelXPReport>()
  
  function limitToThreshold(report: ChannelXPReport) {
    const rep = report.filter(c => c.xp > threshold)
    setDisplaying(rep)
    return rep
  }

  useEffect(() => {
    const rep = report?.filter(c => c.xp > threshold)
    setDisplaying(rep)
  // eslint-disable-next-line
  }, [report])

  return (
    <div>
      {!report &&
        <FetchButton
          user={user}
          apiFunction={reportAPI.getChannelXP}
          loading={loading}
          setLoading={setLoading}
          setReport={setReport}
          callback={limitToThreshold}
          setToast={setToast}
          setUser={setUser}
        />
      }
      {displaying && report &&
      <>
        <FormControl>
          <FormLabel>Threshold</FormLabel>
          <Input type="number"
            value={threshold}
            onChange={(e) => setThreshold(e.currentTarget.valueAsNumber)}
            onKeyDown={(e) => {
              if (e.key === "Enter") limitToThreshold(report)
            }}
            endDecorator={<IconButton onClick={() => limitToThreshold(report)}><Refresh/></IconButton>}
          />
        </FormControl>
        <br/>
        <BarChart
          xAxis={[{ data: displaying.map(r => r.name), scaleType: "band", label: "Channel" }]}
          series={[{ data: displaying.map(r => r.xp), type: "bar" }]}
          barLabel="value"
          height={400}
          yAxis={[{ label: "XP" }]}
        />
      </>
      }
    </div>
  )
}